module.exports = __webpack_public_path__ + "img/logo-2.bff94d61.svg";